const statusColorMap: [string[], string][] = [
  [['executed', 'success', 'delivered', 'complete'], 'bg-green-100 text-green-800'],
  [['confirmed & paid'], 'bg-green-100 text-green-800'],
  [['awaiting'], 'bg-amber-100 text-amber-800'],
  [['confirmed', 'allocated'], 'bg-blue-100 text-blue-800'],
  [['searching carrier'], 'bg-gray-100 text-gray-800'],
  [['choose carrier'], 'bg-amber-100 text-amber-800'],
  [['no carrier'], 'bg-red-100 text-red-700'],
  [['pending'], 'bg-amber-100 text-amber-800'],
  [['carrier'], 'bg-purple-100 text-purple-800'],
  [['error', 'failed'], 'bg-red-100 text-red-700'],
  [['payment'], 'bg-[#C2F5E9] text-[#06A09B]'],
  [['n/a'], 'bg-red-100 text-red-500'],
];

function getStatusStyle(status: string): string {
  const lower = status.toLowerCase();
  for (const [keywords, style] of statusColorMap) {
    if (keywords.some((kw) => lower.includes(kw))) return style;
  }
  return 'bg-gray-100 text-gray-800';
}

export function ShipmentStatusBadge({ status }: { status: string }) {
  return (
    <span
      className={`inline-flex items-center justify-center whitespace-nowrap px-2.5 py-0.5 rounded-3xl text-xs font-medium leading-4 ${getStatusStyle(status)}`}
    >
      {status}
    </span>
  );
}
